export enum TableFilterTypeEnum {
  String = 1,
  Date = 2,
  Number = 3,
  DropDown = 4,
  customRenderTemplate = 5,
  RawString = 6,
  Phone = 7
}
